<template>
  <!-- The new app's migration videos (upgradeVideos.js), played in Mux's player inside a popup.
       Opened from the upgrade banner and from the offer modal, so it sits above that modal. -->
  <div class="uvm-overlay" v-if="video" @mousedown.self="$emit('close')">
    <div class="uvm-dialog" role="dialog" aria-modal="true" :aria-label="video.title">
      <div class="uvm-head">
        <p class="uvm-title">{{ video.title }}</p>
        <button class="uvm-close" type="button" aria-label="Close" @click="$emit('close')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="uvm-frame">
        <iframe
          :src="src"
          :title="video.title"
          allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { upgradeVideoUrl } from './upgradeVideos'

export default {
  name: 'UpgradeVideoModal',
  props: {
    // An entry of upgradeVideos, or null when closed.
    video: { type: Object, default: null }
  },
  computed: {
    src () {
      return this.video ? upgradeVideoUrl(this.video) : ''
    }
  },
  methods: {
    // Captured, and stopped there, so Escape closes only the video when it is open over the offer
    // modal (which listens for Escape on document too).
    onKeydown (event) {
      if (this.video && event.key === 'Escape') {
        event.stopImmediatePropagation()
        this.$emit('close')
      }
    }
  },
  mounted () {
    document.addEventListener('keydown', this.onKeydown, true)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown, true)
  }
}
</script>

<style lang="scss" scoped>
// Same overlay as UpgradeOfferModal (.uom-overlay), but above it (it can open over it) and above the
// page's fixed Support tab (#feedbacklabel), which otherwise draws over the player.
.uvm-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2147483000;
  background: rgba(30, 16, 72, .7);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 18px;
  font-family: Roboto, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.uvm-dialog {
  width: 100%;
  // 16:9 under the header row, and never taller than the window.
  // unquote: the build's Sass would otherwise try to evaluate CSS min() itself.
  max-width: unquote("min(960px, calc((90vh - 52px) * 16 / 9))");
  background: #120a22;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 40px 80px -30px rgba(24, 12, 60, .65);
}

.uvm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 52px;
  padding: 0 12px 0 20px;
}

.uvm-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uvm-close {
  flex: none;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border: 0;
  // The app's global `button` rule sets padding; reset it as UpgradeOfferModal does.
  padding: 0;
  border-radius: 8px;
  cursor: pointer;
  background: rgba(255, 255, 255, .12);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background .15s;

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, .24);
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

.uvm-frame {
  position: relative;
  width: 100%;
  padding-top: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/components/UpgradeVideoModal.vue